/**
 * @file 企业号码认证-公共方法
 * @author *
 */
import moment from 'moment';

export const setOpenInfo = data => {
    const newOpenInfoParam = [];
    data.map(item => {
        if (item.weeks.length > 0 && item.rangeStart && item.rangeEnd) {
            newOpenInfoParam.push({
                day_range: setTags(item.weeks),
                open_time: item.rangeStart,
                close_time: item.rangeEnd
            });
        }
    });
    return newOpenInfoParam;
};

// 设置updataMicroCard（认证企业简介）
export const setOpenHours = openInfo => {
    return openInfo.map((item, index) => {
        return {
            key: index,
            weeks: getWeekNumbers(item.day_range),
            rangeStart: item.open_time,
            rangeEnd: item.close_time
        };
    });
};
function getWeekNumbers(weekLabel) {
    let arr = [];
    weekLabel.split(',').map(item => {
        if (item.indexOf('至') !== -1) {
            const startV = weekDictValue[item.split('至')[0]];
            const endV = weekDictValue[item.split('至')[1]];
            arr = arr.concat(weekDict.slice(startV - 1, endV));
        } else {
            arr = arr.concat(weekDictValue[item]);
        }
    });
    return arr;
}

export function getFieldValue(fields, fieldName) {
    let value = '';
    if (!fields.length) {
        return value;
    }
    fields.map(item => {
        if (item.name[0] === fieldName) {
            value = item.value;
        }
    });
    return value;
}

// 跳转上一步骤页
export function prevPage(batchId, enterType, urlArr, curStep) {
    if (batchId) {
        const enterPage = enterType?.split('-')[0];
        // 编辑页进入上一步，路由增加标志
        if (enterPage === '2' || enterPage === '3') {
            urlArr.splice(3, 3, curStep - 1 + '', batchId, enterPage + '-1');
        } else if (enterPage === '1') {
            urlArr.splice(3, 3, curStep - 1 + '', batchId, enterPage);
        } else {
            urlArr.splice(3, 3, curStep - 1 + '', batchId, '1');
        }
    } else {
        // 新增
        urlArr.splice(3, 1, curStep - 1 + '');
    }
    return urlArr.join('/');
}

export const week = [
    {
        label: '周日',
        value: 7
    },
    {
        label: '周一',
        value: 1
    },
    {
        label: '周二',
        value: 2
    },
    {
        label: '周三',
        value: 3
    },
    {
        label: '周四',
        value: 4
    },
    {
        label: '周五',
        value: 5
    },
    {
        label: '周六',
        value: 6
    }
];

const weekDictLabel = {
    1: '周一',
    2: '周二',
    3: '周三',
    4: '周四',
    5: '周五',
    6: '周六',
    7: '周日'
};
const weekDictValue = {
    周一: 1,
    周二: 2,
    周三: 3,
    周四: 4,
    周五: 5,
    周六: 6,
    周日: 7
};
const weekDict = [1, 2, 3, 4, 5, 6, 7];
export function setTags(data) {
    const dictIndexArr = getDictIndexArr(data);
    const weekArr = getWeekArr(dictIndexArr);
    const newLabel = getNewLabel(weekArr);
    return newLabel;
}
function getDictIndexArr(data) {
    const dictIndexArr = [];
    weekDict.map((dictItem, index) => {
        data.map(selectItem => {
            if (dictItem === selectItem) {
                dictIndexArr.push(index);
            }
        });
    });
    return dictIndexArr;
}
function getWeekArr(dictIndexArr) {
    const newArr = arrange(dictIndexArr);
    return newArr.map(item => {
        return item.map(index => {
            return weekDict[index];
        });
    });
}
function getNewLabel(weekArr) {
    let label = '';
    weekArr.map(item => {
        if (item.length > 2) {
            label += weekDictLabel[item[0]] + '至' + weekDictLabel[item[item.length - 1]] + ',';
        } else {
            item.map(val => {
                label += weekDictLabel[val] + ',';
            });
        }
    });
    return label.substr(0, label.length - 1);
}
function arrange(source) {
    let t;
    let ta;
    const r = [];

    source.forEach(function (v) {
        if (t === v) {
            ta.push(t);
            t++;
            return;
        }

        ta = [v];
        t = v + 1;
        r.push(ta);
    });

    return r;
}
export function hasOpenHoursD(openHours) {
    return openHours.some(item => {
        return item.weeks.length > 0 || item.rangeStart || item.rangeEnd;
    });
}

export function checkNum(data) {
    if (data.weeks.length > 0 && !data.rangeStart && !data.rangeEnd) {
        // 部分选择-起止时间未选
        return '请选择时间';
    } else if (data.weeks.length === 0 && data.rangeStart && data.rangeEnd) {
        // 部分选择-星期未选
        return '请选择星期';
    }
    return '';
}
// 判断时间段重复
export function checkRepeat(value, item) {
    let flag = false;
    // 数组取交集，判断是否重复
    const dictWeeks = new Set(value.weeks);
    const newWeeks = new Set(item.weeks);
    const intersectionArr = Array.from(new Set([...newWeeks].filter(x => dictWeeks.has(x))));
    if (intersectionArr.length && checkInnerTime(item, value)) {
        // 有重复
        flag = true;
    }
    return flag;
}
function checkInnerTime(dict, value) {
    const format = 'YYYY-MM-DD HH:mm';
    const curDate = moment().format('YYYY-MM-DD');
    const startDict = moment(curDate + ' ' + dict.rangeStart).format(format);
    const endDict = moment(curDate + ' ' + dict.rangeEnd).format(format);
    const startValue = moment(curDate + ' ' + value.rangeStart).format(format);
    const endValue = moment(curDate + ' ' + value.rangeEnd).format(format);
    const flag1 = moment(startValue).isAfter(endDict) && moment(endValue).isAfter(startDict);
    const flag2 = moment(startValue).isBefore(endDict) && moment(endValue).isBefore(startDict);
    if (flag1 || flag2) {
        // 不在范围内(无重复)
        return false;
    }
    return true;
}

const typeConsumer = 1;
function compare(p) {
    return function (m, n) {
        const a = m[p];
        const b = n[p];
        return a - b; // 升序
    };
}
// 处理商标名称
const trandSplit = (data, cur) => {
    const ar = data.split(';');
    return ar.indexOf(cur);
};
const phoneFort = (data, display, mydata) => {
    let iey = 0;
    if (display[0]) {
        mydata.push({card: []});
        data.forEach(item => {
            if (item.auth_type === typeConsumer && item.display === display[0]) {
                // 客服认证
                iey++;
                const phoneV = item.phone.split(';')[0];
                const extensionPV = item.phone.split(';')[1] || '';
                const firmCardItem = {
                    display: item.display,
                    numKey: iey,
                    telName: item.phone_display,
                    value: phoneV,
                    initValue: phoneV,
                    errTip: '',
                    expTip: '',
                    displayErr: '成功',
                    extensionP: extensionPV,
                    initExtensionP: extensionPV,
                    reverseDisplay: item.reverse_display || '',
                    trademarkDisplay: '',
                    isqyDisplay: true,
                    status: item.person_status,
                    expiredTime: item.expired_time,
                    bill: item.bill_status,
                    numId: item.id,
                    seq: item.display_seq
                };
                mydata[0].card.push(firmCardItem);
            }
        });
        mydata[0].card.sort(compare('seq'));
    }
};
const trandPhone = (data, display, mydata) => {
    const hasQy = !!display[0];
    for (let i = 1; i < display.length; i++) {
        let iey = 0;
        mydata.push({card: []});
        data.forEach(item => {
            // 判断item位于哪张商标卡中
            const curTrademarkCard = display[i];
            const inList = trandSplit(item.trademark_display, curTrademarkCard);
            if (item.auth_type === typeConsumer && inList !== -1) {
                // 客服认证
                iey++;
                const trademarkSeqArr = item.trademark_seq?.split(';') || [];
                const trademarkTelName = item.trademark_phone_display?.split(';') || [];
                const trademarkCardItem = {
                    display: '',
                    numKey: iey,
                    telName: trademarkTelName[inList] || '',
                    value: item.phone.split(';')[0],
                    initValue: item.phone.split(';')[0],
                    errTip: '',
                    expTip: '',
                    displayErr: '成功',
                    extensionP: item.phone.split(';')[1] || '',
                    initExtensionP: item.phone.split(';')[1] || '',
                    reverseDisplay: item.reverse_display || '',
                    trademarkDisplay: curTrademarkCard,
                    isqyDisplay: false,
                    status: item.person_status,
                    expiredTime: item.expired_time,
                    bill: item.bill_status,
                    numId: item.id,
                    seq: trademarkSeqArr[inList]
                };
                mydata[hasQy ? i : i - 1].card.push(trademarkCardItem);
            }
        });
        mydata[hasQy ? i : i - 1].card.sort(compare('seq'));
    }
};
const displayFormat = (data, type) => {
    let disList = data.map(item => {
        return item.auth_type === type && item.display;
    });

    disList = disList.filter(it => it);
    disList = Array.from(new Set(disList));
    let trandDis = data.map(item => {
        if (item.trademark_display && item.auth_type === type) {
            return item.trademark_display.split(';');
        }
    });
    trandDis = trandDis.filter(it => it);
    trandDis = Array.from(new Set(trandDis.flat(1)));
    trandDis.unshift(disList[0]);
    return trandDis;
};

export const getPhones = list => {
    const displayCard = [];
    const kfDisList = displayFormat(list, typeConsumer);
    phoneFort(list, kfDisList, displayCard);
    trandPhone(list, kfDisList, displayCard);

    return displayCard;
};
